import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const Product = lazyLoad(
  () => import('./index'),
  module => module.default,
  {
    fallback: <LoadingIndicator />,
  },
);
